let UTILS = require("../libs/utils.js");
var v7681;
var v7682;
module.exports = {
  id: "ctf",
  name: "Capture the Flag",
  alias: "ctf",
  endStats: ["sid", "name", "score", "kills", "deaths", "caps", "reward"],
  leaderStats: ["caps", "score"],
  description: "Help your team steal the other team’s flag and bring it to your base. You can’t steal if yours has been stolen. Get it back first by eliminating the carrier.",
  descriptionLang: "game.mode.ctg.description",
  leaderSort: function (p9048, p9049) {
    if (p9048.caps === p9049.caps && p9048.score && p9049.score) {
      return p9048.score - p9049.score;
    } else {
      return p9049.caps - p9048.caps;
    }
  },
  endSort: function (p9050, p9051) {
    if (p9050.caps === p9051.caps && p9050.score && p9051.score) {
      return p9050.score - p9051.score;
    } else {
      return p9051.caps - p9050.caps;
    }
  },
  onKill: function (p9052, p9053, p9054) {
    p9052.dropFlag(p9054.flag);
  },
  flags: true,
  teams: true,
  noScoreC: true
};